import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../classes/api-response';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Company } from '../model/company';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  private readonly crtlPathFragment = 'public';
  private readonly crtlFullPath = `${environment.apiUrl}/${this.crtlPathFragment}`;

  constructor(private http: HttpClient) {
  }

  public submitCompanyRequest(company: Company): Observable<Company> {
    return this.http
      .post<ApiResponse>(`${this.crtlFullPath}/company-request`, company)
      .pipe(map(value => value.data as Company));
  }


}
